export const formatTableValue = (value, precision = 1) => {
  if (value === null || value === undefined || value === "") return "-";

  const number = Number(String(value).replace(",", "."));
  if (Number.isNaN(number)) return "-";

  return Number.isInteger(number) ? number : number.toFixed(precision);
};
